import { render, staticRenderFns } from "./input.vue?vue&type=template&id=ab535e36&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab535e36')) {
      api.createRecord('ab535e36', component.options)
    } else {
      api.reload('ab535e36', component.options)
    }
    module.hot.accept("./input.vue?vue&type=template&id=ab535e36&", function () {
      api.rerender('ab535e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/input.vue"
export default component.exports